<div *ngIf="loading" class="has-text-centered">
  <button  class="button content is-loading" ></button>
</div>
